import { render, staticRenderFns } from "./waitlistHistory.vue?vue&type=template&id=69a67e85&"
import script from "./waitlistHistory.vue?vue&type=script&lang=js&"
export * from "./waitlistHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports